<template>
  <v-data-table
    :headers="defaultHeaders"
    :no-data-text="loadingOrNoDataText"
    :group-desc="false"
    :items="totals"
    hide-default-footer
  />
</template>

<script>
export default {
  Name: 'TotalTable',
  props: {
    defaultHeaders: { type: Array, required: true },
    shares: { type: Map, required: true },
    totalShares: { type: Number, required: true },
    loadingOrNoDataText: { type: String, required: true },
    totalHolders: { type: Number, required: true }
  },
  computed: {
    totals() {
      const total = {
        percentage: 0,
        amountInvested: 0,
        numberOfShares: 0,
        name: this.totalHolders // 'Total'
      }
      for (const series of this.shares.values()) {
        series.reduce((total, share) => {
          total.percentage += (share.numberOfShares / this.totalShares)
          total.amountInvested += share.amountInvested
          total.numberOfShares += share.numberOfShares
          return total
        }, total)
      }

      total.percentage = (total.percentage * 100).toString().concat('%')
      total.amountInvested = total.amountInvested.toFixed(2)
      return [total]
    }
  }

}
</script>

<style>

</style>
